import { fontSize, theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing,
  text = theme.text;
export var heading = /*#__PURE__*/css(["display:flex;align-items:center;justify-content:space-between;width:100%;padding:", " 0 var(--spacing);margin:0;border-top:1px solid var(--neutral-black-30);"], pxToRem(36));
export var title = /*#__PURE__*/css(["", " font-family:", ";font-weight:600;color:var(--neutral-black-base);"], fontSize(text.HEADING.XS), fonts.PRIMARY_SEMIBOLD.family);
export var icon = /*#__PURE__*/css(["width:", ";height:", ";"], pxToRem(spacing.md), pxToRem(spacing.md));